import React from 'react'

import AspectRatio from 'app/components/base/AspectRatio/AspectRatio'
import Box, { BoxProps } from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import Spinner from 'app/components/base/Spinner'
import Text from 'app/components/base/Text'

import { FileModel } from '../../UploadField/UploadField.types'
import DeleteButton from '../DeleteButton'

interface UploadImageItemProps extends Omit<BoxProps, 'id'>, FileModel {
  onDelete: (id: string) => void
  cover?: boolean
  disabled?: boolean
}

const UploadImageItem: RFC<UploadImageItemProps> = ({
  id,
  url,
  loading,
  onDelete,
  cover,
  disabled,
  payload
}) => {
  const currentUrl = payload?.url || url
  const isBlob = currentUrl?.includes('blob:')

  const content = (
    <>
      {currentUrl && !isBlob && (
        <Image
          fill
          src={payload?.url || url}
          alt=""
          sizes="256px"
          quality={100}
          style={{
            objectFit: 'cover',
            opacity: !loading ? 1 : 0.2,
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px'
          }}
        />
      )}
    </>
  )

  return (
    <AspectRatio ratio={1 / 1}>
      <Box
        sx={{
          height: '100%',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'background.default',
          borderWidth: cover ? 0 : 1,
          borderStyle: 'solid',
          borderRadius: '8px',
          borderColor: 'stroke.main',
          overflow: 'hidden'
        }}
      >
        {cover ? (
          <>
            <Box
              sx={{
                p: '3px',
                pb: '18px',
                flex: 1,
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                background: 'linear-gradient(90deg, #17D3FF 0%, #00EA90 100%)',

                '& > span': {
                  width: 'inherit !important',
                  height: 'inherit !important'
                },

                '& > img': { position: 'static !important' }
              }}
            >
              {content}
            </Box>

            <Text
              sx={{
                color: 'common.white',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                textAlign: 'center',
                fontSize: 12,
                lineHeight: '18px',
                fontWeight: 500,
                zIndex: 1
              }}
            >
              Cover
            </Text>
          </>
        ) : (
          <Box sx={{ width: '100%', height: '100%' }}>{content}</Box>
        )}

        {loading && <Spinner sx={{ position: 'absolute', m: 'auto' }} />}

        {!disabled && (
          <DeleteButton
            onClick={() => onDelete(id)}
            size={25}
            sx={{ position: 'absolute', right: 0, top: 0 }}
          />
        )}
      </Box>
    </AspectRatio>
  )
}
export default UploadImageItem
